import { inject } from "aurelia-framework";
import { LocaleService } from "../services/locale-service";

@inject(LocaleService)
export class KGridRendererFactory {
  constructor(private localeService: LocaleService) {}

  public floatFormatter(formatMask?: string): (params: any) => string {
    let that = this;
    return (params) =>
      params.value && that.localeService.formatFloat(params.value, formatMask);
  }

  public intFormatter(formatMask?: string): (params: any) => string {
    let that = this;
    return (params) =>
      params.value && that.localeService.formatInt(params.value, formatMask);
  }
}
